module.exports = __webpack_public_path__ + "static/img/start-recording.c342cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/start-recording.png
// module id = Ofn1
// module chunks = 54